import ReactDOM from "react-dom";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { useState } from "react";
import { Progress } from "antd";

import "./UploadingPopup.scss";

const UploadingPopup = ({ uploadingList = [], completedUploads = 0, currentUploadProgress = 0 }) => {
  const [collapsed, setCollapsed] = useState(false);

  const onClose = () => {
    const listUploading = document.querySelector(".list-uploading");
    setCollapsed(!collapsed);

    if (collapsed) {
      listUploading.style.display = "block";
    } else {
      listUploading.style.display = "none";
    }
  };

  const total = uploadingList.length;
  const overallPercent = total > 0
    ? Math.round(((completedUploads + currentUploadProgress / 100) / total) * 100)
    : 0;

  const getFileStatus = (index) => {
    if (index < completedUploads) return { label: "Uploaded", percent: 100 };
    if (index === completedUploads) return { label: `Uploading... ${currentUploadProgress}%`, percent: currentUploadProgress };
    return { label: "Waiting...", percent: 0 };
  };

  function bytesToMB(bytes) {
    return (bytes / 1048576).toFixed(2);
  }

  if (total > 0) {
    return ReactDOM.createPortal(
      <div className="popup-container">
        <div className="popup-content">
          <div className="title-upload">
            <span>Uploads</span>
            {collapsed ? (
              <UpOutlined className="close-btn" onClick={onClose} />
            ) : (
              <DownOutlined className="close-btn" onClick={onClose} />
            )}
          </div>
          <div className="list-uploading">
            {uploadingList?.map((file, index) => {
              const status = getFileStatus(index);
              const uploadedMb = index < completedUploads
                ? bytesToMB(file.size)
                : index === completedUploads
                  ? bytesToMB(file.size * currentUploadProgress / 100)
                  : "0.00";
              return (
                <div className="uploadFile" key={file.name + file.size}>
                  <div className="fileInfo">
                    <div className="file-info">
                      <div>{file.name}</div>
                      <div className="upload-info">
                        {status.label} - {uploadedMb} / {bytesToMB(file.size)} MB
                      </div>
                    </div>
                  </div>
                  <Progress
                    percent={status.percent}
                    status="active"
                    showInfo={false}
                    strokeColor="#4c72cd"
                  />
                </div>
              );
            })}
          </div>
        </div>
        <div className="bottom-upload-popup">
          <div className="bottom-text">
            Uploaded {completedUploads} / {total} items
          </div>
          <div className="percentage" style={{ width: `${overallPercent}%` }} />
        </div>
      </div>,
      document.body
    );
  }
  return null;
};

export default UploadingPopup;
